import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INavigationBarItemInterface } from '@ispm/navigation/interfaces';

@Component({
  selector: 'gen-navigation-bar-item',
  templateUrl: './navigationBarItem.component.html',
  styleUrls: [ './navigationBarItem.component.scss' ]
})
export class NavigationBarItemComponent {
  @Input() public isDropdown: boolean = false;
  @Input() public isFirst: boolean;
  @Input() public selected: boolean = false;
  @Input() public item: INavigationBarItemInterface;

  @Output() public onNavigationClick: EventEmitter<INavigationBarItemInterface> = new EventEmitter<INavigationBarItemInterface>();

  constructor() {
  }
}
